import { useEffect, useState } from "react";

function parseTimeToSeconds(time: string) {
    const [h, m, s] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
}

function formatSeconds(sec: number) {
    const yearInSec = 365 * 86400;
    const monthInSec = 30 * 86400;
    const dayInSec = 86400;

    const years = Math.floor(sec / yearInSec);
    let remainder = sec % yearInSec;

    const months = Math.floor(remainder / monthInSec);
    remainder %= monthInSec;

    const days = Math.floor(remainder / dayInSec);
    remainder %= dayInSec;

    const hours = Math.floor(remainder / 3600);
    remainder %= 3600;

    const minutes = Math.floor(remainder / 60);
    const seconds = remainder % 60;

    const timeStr = [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
        String(seconds).padStart(2, "0")
    ].join(":");

    const dateParts = [];
    if (years > 0) dateParts.push(`${years} năm`);
    if (months > 0) dateParts.push(`${months} tháng`);
    if (days > 0) dateParts.push(`${days} ngày`);

    if (dateParts.length > 0) {
        return `${dateParts.join(" ")} - ${timeStr}`;
    }
    return timeStr;
}

interface CountdownProps {
    initial?: string;
    endDate?: string;
}

export default function Countdown({ initial, endDate }: CountdownProps) {
    const calculateSeconds = () => {
        if (endDate) {
            const end = new Date(endDate).getTime();
            const now = new Date().getTime();
            return Math.max(0, Math.floor((end - now) / 1000));
        }
        if (initial) {
            return parseTimeToSeconds(initial);
        }
        return 0; // Default or fallback
    };

    const [seconds, setSeconds] = useState(calculateSeconds());

    useEffect(() => {
        setSeconds(calculateSeconds());
    }, [initial, endDate]);

    useEffect(() => {
        if (seconds <= 0) return;

        const timer = setInterval(() => {
            setSeconds(prev => Math.max(0, prev - 1));
        }, 1000);

        return () => clearInterval(timer);
    }, [seconds]);

    return (
        <div style={{ display: "inline-block" }}>
            {formatSeconds(seconds)}
        </div>
    );
}
